import Legacy from "./Legacy";
export default Legacy;
